import apiClient, { saveAuthData } from './authService';
import { AUTH_ENDPOINTS, AUTH_METHODS } from '../utils/authConstants';

export const cognitoService = {
  // Register user with Cognito
  register: async (userData) => {
    try {
      const response = await apiClient.post(AUTH_ENDPOINTS.COGNITO.REGISTER, {
        email: userData.email,
        password: userData.password,
        first_name: userData.firstName,
        last_name: userData.lastName,
        phone: userData.phone,
        company_id: userData.companyId,
        role: userData.role || 'buyer'
      });
      
      if (response.data.success) {
        saveAuthData(response.data.data, AUTH_METHODS.COGNITO);
      }
      
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Login with Cognito
  login: async (email, password) => {
    try {
      const response = await apiClient.post(AUTH_ENDPOINTS.COGNITO.LOGIN, {
        email,
        password
      });
      
      if (response.data.success) {
        saveAuthData(response.data.data, AUTH_METHODS.COGNITO);
      }
      
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Link existing account with Cognito
  linkAccount: async (email, password, currentToken) => {
    try {
      const response = await apiClient.post(AUTH_ENDPOINTS.COGNITO.LINK_ACCOUNT, {
        email,
        password
      }, {
        headers: {
          Authorization: `Bearer ${currentToken}`
        }
      });
      
      if (response.data.success) {
        saveAuthData(response.data.data, AUTH_METHODS.COGNITO);
      }
      
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get Cognito service status
  getStatus: async () => {
    try {
      console.log('🔍 CognitoService.getStatus - Endpoint:', AUTH_ENDPOINTS.COGNITO.STATUS);
      console.log('🔍 CognitoService.getStatus - apiClient baseURL:', apiClient.defaults.baseURL);
      console.log('🔍 CognitoService.getStatus - Full URL will be:', apiClient.defaults.baseURL + AUTH_ENDPOINTS.COGNITO.STATUS);
      
      const response = await apiClient.get(AUTH_ENDPOINTS.COGNITO.STATUS);
      return response.data;
    } catch (error) {
      console.error('❌ CognitoService.getStatus error:', error);
      throw error.response?.data || error;
    }
  }
};